export default class CheckType {
  // Чеки для клиента
  static get ClientCheck () { return 'client_check' }
  static get MenuItemsComposition () { return 'menu_items_composition' }

  // Чеки на кухню
  static get KitchenCheck () { return 'kitchen_check' }
  static get KitchenCorrectionCheck () { return 'kitchen_correction_check' }
  static get KitchenCancelCheck () { return 'kitchen_cancel_check' }

  // Фискальные чеки
  static get FiscalSellCheck () { return 'fiscal_sell_check' }
  static get FiscalRefundCheck () { return 'fiscal_refund_check' }
  static get FiscalSellCorrectionCheck () { return 'fiscal_sell_correction_check' }
  static get FiscalRefundCorrectionCheck () { return 'fiscal_refund_correction_check' }

  // Служебные фискальные чеки
  static get OpenShift () { return 'open_shift' }
  static get CloseShift () { return 'close_shift' }
  static get XReport () { return 'x_report' }

  // Терминал
  static get TerminalSettlement () { return 'terminal_settlement' }
  static get TerminalReport () { return 'terminal_report' }
  static get TerminalReportDetailed () { return 'terminal_report_detailed' }

  static getName (enumValue) {
    switch (enumValue) {
      // Чеки для клиента
      case this.ClientCheck:
        return 'Чек клиента'
      case this.MenuItemsComposition:
        return 'Состав блюд'

      // Чеки на кухню
      case this.KitchenCheck:
        return 'Чек для кухни'
      case this.KitchenCorrectionCheck:
        return 'Чек коррекции для кухни'
      case this.KitchenCancelCheck:
        return 'Чек отмены для кухни'

      // Фискальные чеки
      case this.FiscalSellCheck:
        return 'Чек продажи (фискальный)'
      case this.FiscalSellCorrectionCheck:
        return 'Чек коррекции продажи (фискальный)'

      case this.FiscalRefundCheck:
        return 'Чек возврата (фискальный)'
      case this.FiscalRefundCorrectionCheck:
        return 'Чек коррекции возврата (фискальный)'

      // Служебные фискальные чеки
      case this.OpenShift:
        return 'Открытие смены'
      case this.CloseShift:
        return 'Закрытие смены'
      case this.XReport:
        return 'X-отчет'

      // Терминал
      case this.TerminalSettlement:
        return 'Сверка итогов терминала'
      case this.TerminalReport:
        return 'Итоги дня терминала (краткий)'
      case this.TerminalReportDetailed:
        return 'Итоги дня терминала (полный)'

      default:
        return enumValue
    }
  }

  static getAllVariants () {
    const variants = [
      // Чеки для клиента
      this.ClientCheck,
      this.MenuItemsComposition,

      // Чеки на кухню
      this.KitchenCheck,
      this.KitchenCorrectionCheck,
      this.KitchenCancelCheck,

      // Фискальные чеки
      this.FiscalSellCheck,
      this.FiscalRefundCheck,
      this.FiscalSellCorrectionCheck,
      this.FiscalRefundCorrectionCheck,

      // Служебные фискальные чеки
      this.OpenShift,
      this.CloseShift,
      this.XReport,

      // Терминал
      this.TerminalSettlement,
      this.TerminalReport,
      this.TerminalReportDetailed,
    ]

    return variants.map(item => ({
      value: item,
      name: this.getName(item),
    }))
  }
}
